import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseHttpService } from './base-http.service';
import { Project } from '@core/types/sidebar.type';

export type Customer = {
  number: string;
  mainAddress: { name1: string; };
};
export type Employee = {
  fullName: string;
  firstName: string;
  lastName: string;
  number: number;
};
export type CostCenterRegion = {
  number: string;
  localizedName: string;
};
export type BaseData = {
  shortName?: string | null;
  costCenterNumber?: string | null;
  buildingOwner?: string | null;
  costCenterRegion?: CostCenterRegion | null;
};
export type Address = {
  streetOne: string | null;
  streetTwo: string | null;
  zipCode: string | null;
  city: string | null;
  country: {
    iso2: string | null;
    name: string | null;
  } | null;
};
export type Audit = {
  createdAt: string;
  creator: string;
  enabled: boolean;
  version: number;
};
export interface FullProject {
  id: number;
  number: string;
  name: string;
  completed: boolean;
  plannedStart: string;
  plannedEnd: string;
  image?: string | null;
  emails?: Record<string, string> | null;
  address: Address;
  baseData?: BaseData | null;
  audit?: Audit | null;
  customer?: Customer;
  status?: 'active' | 'inactive';
}
/** Status-Codes wie im UI */
export type ProjectStatusCode = 'active' | 'inactive';
@Injectable()
export class HttpService extends BaseHttpService<HttpService> {
  private readonly _http: HttpClient = inject(HttpClient);

  getProject (number: number | string): Observable<Project> {
    const url: string = `api/projects/${ number }`;

    return this._http.get<Project>(url, { params: { expand: "DEFAULT" } });
  }

  getFullProject (number: string): Observable<FullProject> {
    const url: string = `api/projects/${ number }`;

    return this._http.get<FullProject>(url, { params: { expand: [ "ADDRESS", "AUDIT", "IMAGE" ] } });
  }

  getCustomer (number: number): Observable<Customer> {
    const url: string = `api/customers/${ number }`;

    return this._http.get<Customer>(url);
  }
}
